<template>
	<div style="width:90%">
		<!-- 查询 -->
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.uid" placeholder="请输入用户ID"></el-input>
					</el-form-item>
					<el-form-item label="设备ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.deviceid" placeholder="请输入用户ID"></el-input>
					</el-form-item>
					<el-form-item label="订单号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.orderid" placeholder="请输入订单号">
						</el-input>
					</el-form-item>
					<!-- <el-form-item label="订单状态:" label-width="80px">
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="0" label="待付款" :value="0">待付款</el-option>
							<el-option key="1" label="待发货" :value="1">待发货</el-option>
							<el-option key="2" label="待收货" :value="2">待收货</el-option>
							<el-option key="3" label="已完成" :value="3">已完成</el-option>
						</el-select>
					</el-form-item> -->
					<!--  -->
					<!-- 	<el-form-item label="所属区域:" label-width="80px">
						<el-select clearable filterable v-model="searchInfo.provinceId" placeholder="请选择省"
							@change="provinceFocus">
							<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="searchInfo.cityId" placeholder="请选择市"
							@change="cityFcus">
							<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="searchInfo.areaId" placeholder="请选择区"
							@change="districtFcus">
							<el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="支付时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- el-button type="primary" @click="downloadFile">
								导出
								</el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<!-- 列表展示 -->
		<el-table :data="orderList" stripe style="width: 100%" v-loading="loading" element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading">
			<!-- 			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column> -->
			<el-table-column prop="id" label="#" align="center" width="90" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="uid" label="用户ID" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="phone" label="手机号" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="fromname" label="订单来源" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="deviceid" label="设备ID" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="dname" label="设备名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="daddress" label="设备地址" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="type" label="订单类型" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.type==0">商城订单</span>
					<span v-if="scope.row.type==1">兑换订单</span>
					<span v-if="scope.row.type==3">社区店订单</span>
				</template>
			</el-table-column> -->
			<el-table-column prop="orderid" label="订单号" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="omoney" label="订单总价(￥)" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="ostatus" label="订单状态" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="oremark" label="备注" align="center" width="" :show-overflow-tooltip="true">
				<template v-slot="scope">
					{{scope.row.oremark? scope.row.oremark:'无'}}
				</template>
			</el-table-column>
			<!-- 	<el-table-column prop="address" label="所属区域" align="center" width="180" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="oaddtime" label="下单时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="paytime" label="支付时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="olasttime" label="结束时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop=""  label="操作"  fixed="right" align="center" width="180" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showContent(scope.row.orderid)">查看详情</el-button>
					<!-- <el-button v-if="scope.row.status==1" size="small" type="text" @click="showDeliver(scope.row)">发货 -->
					<!-- </el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 订单详情对话框 -->
		<el-dialog title="订单详情" :visible.sync="dialogVisible" width="60%" :before-close="handleClose"
			:close-on-click-modal="false">
			<div>
				<div style="margin:10px 0">商品详情</div>
				<!-- 列表展示 -->
				<el-table :data="orderInfo" stripe style="width: 100%" v-loading="loading" element-loading-text="拼命加载中"
					element-loading-spinner="el-icon-loading">
					<!-- 			<el-table-column type="index" align="center" width="90" label="#">
					</el-table-column> -->
					<el-table-column prop="id" label="订单id" align="center" width="90" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="orderid" label="订单编号" align="center" width="" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="skuTitle" label="商品名称" align="center" width="" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="skuPrice" label="单价" align="center" width="" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="skuCutmoney" label="优惠" align="center" width=""
						:show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="skuCsnoMoney" label="红包金额" align="center" width=""
						:show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="skuNum" label="数量" align="center" width="" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="skuDiscount" label="折扣" align="center" width=""
						:show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="sum" label="小计" align="center" width="" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="oremark" label="备注" align="center" width="" :show-overflow-tooltip="true">
						<template v-slot="scope">
							{{scope.row.oremark? scope.row.oremark:'无'}}
						</template>
					</el-table-column>
				</el-table>

			</div>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
				<el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
		<!-- 发货 -->
		<el-dialog style="float:rigin" title="发货" :visible.sync="deliverDialog" width="30%"
			:close-on-click-modal="false">
			<div class="app-container" style="text-align: center;">
				<el-form label-width="100px" size="medium">
					<el-form-item label="物流:">
						<el-col :span="12">
							<el-select clearable filterable v-model="expressId" class="big" placeholder="请选择" clear>
								<el-option v-for="item in expressList" :key="item.id" :value="item.id"
									:label="item.expressName">
								</el-option>
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="快递单号:">
						<el-col :span="15">
							<el-input type="text" v-model="expressCode" placeholder="请输入快递单号" />
						</el-col>
					</el-form-item>
					<el-form-item label="发货人:">
						<el-col :span="15">
							<el-input type="text" v-model="sendOpUser" placeholder="请输入发货人" />
						</el-col>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="deliverDialog = false">取 消</el-button>
				<el-button type="primary" @click="deliverGoods">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				orderList: [],
				dialogVisible: false,
				searchInfo: {},
				orderInfo: {},
				sliderlist: {},
				// provinceList: [],
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				provinceList: {},
				cityList: {},
				districtList: {},
				deliverDialog: false, //发货弹窗
				sendOpUser: '', // 发货人
				expressCode: '', // 快递订单号
				expressId: '', // 快递公司id
				expressList: [], //快递公司列表
				showOrderInfo: [] //发货订单信息
			};
		},
		methods: {
			/**
			 * 文件导出
			 */
			downloadFile() {
				let data = {
					userName: this.searchInfo.username,
					orderCode: this.searchInfo.orderCode,
					status: this.searchInfo.status,
					type: this.searchInfo.type,
					provinceId: this.searchInfo.provinceId,
					cityId: this.searchInfo.cityId,
					areaId: this.searchInfo.areaId,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.exportExcel(data).then((res) => {
					console.log(res.data)
					this.showloadFile(res.data)
				})
			},
			showloadFile(res) {
				if (!res) {
					return
				}
				const link = document.createElement('a');
				let blob = new Blob([res], {
					type: 'application/vnd.ms-excel'
				});
				link.style.display = 'none';
				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', '商城订单' + '.xls');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			//确认发货
			deliverGoods() {
				var data = {
					expressCode: this.expressCode,
					sendOpUser: this.sendOpUser,
					expressId: this.expressId,
					storeId: this.showOrderInfo.storeId,
					status: 2,
					id: this.showOrderInfo.id
				}
				this.$api.editStoreOrderStatus(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.storeOrderList();
						this.deliverDialog = false
					} else {
						this.$message.error(res.message);
					}
				})

			},
			//快递公司列表
			findExpress() {
				this.$api.findAllOrderExpressList({}).then((res) => {
					if (res.state == 'success') {
						this.expressList = res.data.list
					}
				})
			},
			//展示发货弹窗
			showDeliver(item) {
				this.showOrderInfo = []
				this.expressCode = ""
				this.sendOpUser = ""
				this.expressId = ""
				this.findExpress();
				this.showOrderInfo = item
				this.deliverDialog = true
			},
			// 查询
			search() {
				this.page.pageNum = 1;
				this.storeOrderList()
			},
			// 清空
			empty() {
				this.searchInfo = {}

			},
			storeOrderList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					uid: this.searchInfo.uid,
					orderid: this.searchInfo.orderid,
					deviceid: this.searchInfo.deviceid,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : '',
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : '',
				}
				this.$api.jiuguiOrderZhuList(data).then((res => {
					if (res.state == 'success') {
						this.orderList = res.data.list
						this.sliderlist = res.data
						this.loading = false
					}
				}))
				//查询省
				this.$api.getAreasFive(0).then((res) => {
					if (res.state == 'success') {
						this.provinceList = res.data
					}
				})
			},
			//查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.province = obj.name
				this.orderInfo.cityId = ""
				// this.setTLevelData.areaId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.city = obj.name
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},

			districtFcus(e) {
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.area = obj.name
			},
			// 订单详情查询
			showContent(e) {
				let data = {
					orderid: e
				}
				this.$api.jiuguiOrderCong(data).then((res) => {
					if (res.state == 'success') {
						this.orderInfo = res.data
						this.dialogVisible = true

					}
				})
			},
			handleClose() {
				this.dialogVisible = false
			},
			pageChange(data) {
				this.page.pageNum = data
				this.storeOrderList();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.storeOrderList()
			},
		},
		created() {
			this.storeOrderList();
		},
	};
</script>

<style>
	.orderxq {
		display: flex;
		width: 50%;
		align-items: flex-start;
	}

	.orderList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

	}
</style>
